import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';

const LegacySiteNavLink = (props) => {
    if (props.type === 'next') {
        return <a href={props.to}>{props.children}</a>;
    }

    return <NavLink {...props} />;
};

LegacySiteNavLink.propTypes = {
    children: PropTypes.node.isRequired,
    to: PropTypes.string,
    type: PropTypes.string,
};

export default LegacySiteNavLink;
